import swal from 'sweetalert2'

// Confirms a write to the user with the server's message, when it sent one.
// `translate` is the `responseMessages` namespace's t.
export default function showResponseText(payload, translate) {
  if (!payload?.responseText) return
  swal.fire({
    position: 'center',
    icon: 'success',
    title: translate(payload.responseText),
    showConfirmButton: false,
    timer: 1500,
  })
}

// The same, for the messages the server wrote with spaces where the
// translation files have dashes.
export function showDashedResponseText(payload, translate) {
  showResponseText(payload, (key) => translate(key.replaceAll(' ', '-')))
}

// The error toast every write falls back on when something throws around it.
// The request helpers have already shown their own error for a failed
// request; this is for anything else.
export function showProblem(translate) {
  swal.fire({
    position: 'center',
    icon: 'error',
    title: translate('problem'),
    showConfirmButton: true,
  })
}
